import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";
import { Toast,ToastContainer } from "react-bootstrap";
import FormNuevaCita from "./FormNuevaCita";
import { getElementosHora, convertirHoraMilitarA12h } from "../../../resources/Helper";
import { saveAgendaFocusAndNavigate } from "../../../resources/agendaFocusNavigation";

const estiloCeldaHover = {
    display: 'inline-block',
    maxWidth: '280px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
};

function celdaConHover(valor) {
    const t = valor != null && valor !== '' ? String(valor) : '';
    return <span title={t || undefined} style={estiloCeldaHover}>{t || '—'}</span>;
}

const opcionesPaginacionES = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todas',
};

const estilosTabla = {
    headCells: {
        style: { fontSize: '13px', fontWeight: 600 },
    },
    cells: {
        style: { fontSize: '13px' },
    },
};


function BusquedaCitas() {

    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    const [estadosCita, setEstadosCita] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [agendas, setAgendas] = useState([]);
    const [unidades, setUnidades] = useState([]);

    const [terminoBusqueda, setTerminoBusqueda] = useState();
    const [estadoCita, setEstadoCita] = useState();
    const [fechaInicial, setFechaInicial] = useState();
    const [fechaFinal, setFechaFinal] = useState();
    const [profesional, setProfesional] = useState();
    const [unidad, setUnidad] = useState();

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);


    //////////////////////////

    const [modalState, setModalState] = useState('hidden');
    const [verCitaModalState, setVerCitaModalState] = useState('hidden');

    const [profesionalAsignado, setProfesionalAsignado] = useState();
    //const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState();
    const [usuarioAsigna, setUsuarioAsigna] = useState();
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState();
    const [primerNombre, setPrimerNombre] = useState();
    const [segundoNombre, setSegundoNombre] = useState();
    const [primerApellido, setPrimerApellido] = useState();
    const [segundoApellido, setSegundoApellido] = useState();
    const [email, setEmail] = useState();
    const [celular, setCelular] = useState();
    const [tipoDocumento, setTipoDocumento] = useState();
    const [numeroDocumento, setNumeroDocumento] = useState();
    const [idPaciente, setIdPaciente] = useState();
    const [idCita, setIdCita] = useState();

    const [fechaCita, setFechaCita] = useState('');
    const [horaCita, setHoraCita] = useState('');
    const [duracion, setDuracion] = useState('');
    const [estado, setEstado] = useState('');
    const [horaAtencionCita, setHoraAtencionCita] = useState('');
    const [minutoCita, setMinutoCita] = useState('');
    const [ampmCita, setAmpmCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');

    //////////////////////////

    let userdata = [];
    let clientData = [];

    const cols = [
        { name: 'Paciente', cell: (row) => celdaConHover(getNombre(row)), sortable: true },
        { name: 'Fecha', selector: (row) => row.fecha_cita, sortable: false, cell: (row) => celdaConHover(row.fecha_cita) },
        { name: 'Hora', selector: (row) => convertirHoraMilitarA12h(row.hora_cita), sortable: false, cell: (row) => celdaConHover(convertirHoraMilitarA12h(row.hora_cita)) },
        { name: 'Duración', selector: (row) => row.duracion_cita, sortable: false, cell: (row) => celdaConHover(row.duracion_cita) },
        { name: 'Estado', sortable: false, cell: (row) => getEstado(row) },
        { name: 'Celular', sortable: false, cell: (row) => celdaConHover(row.celular) },
        { name: 'Agenda', sortable: false, cell: (row) => celdaConHover(row.agenda_nombre) },
        { name: 'Acciones', cell: (row) => getBotones(row), minWidth: '100px' },
    ];

    const irAAgendaDesdeFila = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (!item.id_users || !item.fecha_cita) return;
        saveAgendaFocusAndNavigate(history, {
            agendaId: item.id_users,
            agendaNombre: item.agenda_nombre,
            fechaCita: item.fecha_cita,
            horaCita: item.hora_cita,
            citaId: item.id,
        });
    };

    const getBotones = (item) => {
        return (
            <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px' }}>
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={(e) => irAAgendaDesdeFila(e, item)} title="Ir a agenda" aria-label="Ir a agenda">
                    <i className="far fa-calendar-alt" aria-hidden="true" />
                </button>
                <button type="button" className="btn btn-primary btn-sm" onClick={(e) => verCita(e, item)} title="Editar" aria-label="Editar">
                    <i className="far fa-edit" aria-hidden="true" />
                </button>
            </div>
        );
    };

    function getEstado(item) {

        return item.estado_cita=='Cancelada' ? <>{item.estado_cita+' '}<a href="#" onClick={(e) => reagendarCita(e,item)} className="btn btn-primary btn-sm">Reagendar</a></> : item.estado_cita
    }


    function reagendarCita(e,item) {
        e.preventDefault();

        setPrimerNombre(item.primer_nombre);
        setSegundoNombre(item.segundo_nombre);
        setPrimerApellido(item.primer_apellido);
        setSegundoApellido(item.segundo_apellido);
        setEmail(item.cita_email || item.email || '');
        setCelular(item.cita_celular || item.cita_telefono || item.celular || '');
        setTipoDocumento(item.tipo_documento);
        setNumeroDocumento(item.numero_documento);
        setIdPaciente(item.id_paciente);
        setIdCita(item.id);
        setProfesionalAsignado(item.id_users);

        setModalState('visible');
    }

    const getNombre = (item) => {
        const sn = item.segundo_nombre ? ' ' + item.segundo_nombre : '';
        const sa = item.segundo_apellido ? ' ' + item.segundo_apellido : '';
        return `${item.primer_nombre || ''}${sn} ${item.primer_apellido || ''}${sa}`.replace(/\s+/g, ' ').trim() || '—';
    }

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        axios.get('/estados-cita?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEstadosCita(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('profesionales?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            })

        axios.get('/agendas-usuario', config)
            .then(response => {
                if (response.status === 200) {
                    setAgendas(Array.isArray(response.data) ? response.data : []);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('unidades-atencion?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUnidades(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            })
    },[]);




    useEffect(() => {

        recargarCitas();
    },[terminoBusqueda,estadoCita,fechaInicial,fechaFinal,profesional,unidad]);


    function recargarCitas() {

        setItems([]);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                nombre: terminoBusqueda,
                estado_cita: estadoCita,
                fecha_inicio: fechaInicial,
                fecha_fin: fechaFinal,
                profesional: profesional,
                unidad: unidad
            }
        }

        axios.get('/busqueda-citas',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error.response.data);
            })
    }


    function handleCitaReagendada() {

        setToastMsg('La cita ha sido reagendada');
        recargarCitas();
    }


    function handleCitaModificada() {
        setToastMsg('La cita ha sido modificada');
        recargarCitas();
    }


    const verCita = (e, cita) => {
        e.preventDefault();

        setPrimerNombre(cita.primer_nombre);
        setSegundoNombre(cita.segundo_nombre);
        setPrimerApellido(cita.primer_apellido);
        setSegundoApellido(cita.segundo_apellido);
        setEmail(cita.cita_email || cita.email || '');
        setCelular(cita.cita_celular || cita.cita_telefono || cita.celular || '');
        setTipoDocumento(cita.tipo_documento);
        setNumeroDocumento(cita.numero_documento);
        setIdPaciente(cita.id_paciente);
        setIdCita(cita.id);
        setProfesionalAsignado(cita.id_users);

        setFechaCita(cita.fecha_cita);
        setHoraCita(cita.hora_cita);
        setDuracion(cita.duracion_cita);
        setEstado(cita.id_estado_cita);

        const fechaISO = new Date(cita.fecha_cita);

        setHoraAtencionCita(getElementosHora(cita.hora_cita)[0]);
        setMinutoCita(getElementosHora(cita.hora_cita)[1]);
        setAmpmCita(getElementosHora(cita.hora_cita)[2]);
        setUnidadAtencion(cita.id_unidad_atencion);

        setVerCitaModalState('visible');
    }



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/agenda">Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Búsqueda de citas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Búsqueda de citas</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="row" style={{marginBottom: '30px'}}>
                             
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Nombre/apellidos paciente</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="profesional">Agenda</label>
                                    <select name="profesional" id="profesional" className="form-control" onChange={(e) => setProfesional(e.target.value)}>
                                        <option></option>
                                        {
                                            agendas.map((agenda) => 
                                                <option key={agenda.id} value={agenda.id}>{agenda.nombre}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="estadoCita">Estado de la cita</label>
                                    <select name="estadoCita" id="estadoCita" className="form-control" onChange={(e) => setEstadoCita(e.target.value)}>
                                        <option></option>
                                        {
                                            estadosCita.map((ec) => 
                                                <option key={ec.id} value={ec.id}>{ec.nombre}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="unidad">Unidad de atención</label>
                                    <select name="unidad" id="unidad" className="form-control" onChange={(e) => setUnidad(e.target.value)}>
                                        <option></option>
                                        {
                                            unidades.map((uni) => 
                                                <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="fechaInicial">Fecha inicial</label>
                                    <input type="date" name="fechaInicial" className="form-control" id="fechaInicial" onChange={(e) => setFechaInicial(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="fechaFinal">Fecha final</label>
                                    <input type="date" name="fechaFinal" className="form-control" id="fechaFinal" onChange={(e) => setFechaFinal(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                highlightOnHover
                                customStyles={estilosTabla}
                                paginationComponentOptions={opcionesPaginacionES}
                                noDataComponent={<div className="p-4 text-center text-muted">No hay citas que mostrar</div>}
                                id={'citas'}
                                />

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>


                
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>

                <ToastContainer className="toast-exito">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                        <Toast.Body>{toastMsg}</Toast.Body>
                    </Toast>
                </ToastContainer>



                <FormNuevaCita 
                            modalState={modalState} 
                            closeModal={modalState => setModalState('hidden')} 
                            profesionalAsignado={profesionalAsignado}
                            nombreUsuarioAsigna={nombreUsuarioAsigna}
                            primerNombre={primerNombre}
                            segundoNombre={segundoNombre}
                            primerApellido={primerApellido}
                            segundoApellido={segundoApellido}
                            email={email}
                            celular={celular}
                            tipoDocumento={tipoDocumento}
                            numeroDocumento={numeroDocumento}
                            verCita={false}
                            puedeAtender={false}
                            idPaciente={idPaciente}
                            primeraVez={true}
                            idCita={idCita}
                            reloadCitasAgenda={handleCitaReagendada}

                            stepCita={'20'}
                />


                <FormNuevaCita
                                modalState={verCitaModalState} 
                                closeModal={() => setVerCitaModalState('hidden')} 
                                profesionalAsignado={profesionalAsignado}
                                nombreUsuarioAsigna={nombreUsuarioAsigna}
                                primerNombre={primerNombre}
                                segundoNombre={segundoNombre}
                                primerApellido={primerApellido}
                                segundoApellido={segundoApellido}
                                email={email}
                                celular={celular}
                                tipoDocumento={tipoDocumento}
                                numeroDocumento={numeroDocumento}
                                verCita={true}
                                puedeAtender={true}
                                idPaciente={idPaciente}
                                primeraVez={true}
                                idCita={idCita}
                                reloadCitasAgenda={handleCitaModificada}
                                stepCita={'20'}
                                fecha={fechaCita}
                                hora={horaCita}
                                duracionCita={duracion}
                                estadoCita={estado}
                                horaAtencionCita={horaAtencionCita}
                                minutoCita={minutoCita}
                                ampmCita={ampmCita}
                                unidadAtencion={unidadAtencion}

                />
                
                <Footer showToast={false} delay={0} message={toastMsg} />

            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default BusquedaCitas;